// @flow

import { get, has, isEmpty } from 'lodash';

type State = Array<*>;

type TransferUpdateFields = {
  id: string,
  availableTransfers: Array<*>,
  selectedTransfers: Array<*>,
  paymentSchedule: PaymentSchedule,
  price: ?ProposalPrice,
  attendees: ProposalAttendees,
};

function getTransportsWithTransfer(proposal: Proposal): Transport {
  return {
    ...proposal.transports,
    inbound: { ...get(proposal, 'transports.inbound'), transferIncluded: true },
    outbound: { ...get(proposal, 'transports.outbound'), transferIncluded: true },
  };
}

function setTransferIncludedInProposal(proposal: Proposal): Proposal {
  return {
    ...proposal,
    ...(has(proposal, 'transports.inbound') && has(proposal, 'transports.outbound')
      ? { transports: getTransportsWithTransfer(proposal) }
      : null),
  };
}

function updateProposal(proposalId: string, state: State, updateFn: Proposal => Proposal): State {
  const indexToUpdate = state.findIndex(p => get(p, 'id') === proposalId);
  return indexToUpdate !== -1
    ? state.map((proposal, index) => (index === indexToUpdate ? updateFn(proposal) : proposal))
    : state;
}

function updateTransfers(state: State, proposalFields: Array<TransferUpdateFields>): State {
  if (isEmpty(proposalFields)) return state;

  const updateFn = proposal => {
    const currentProposal = proposalFields.find(({ id }) => id === get(proposal, 'id')) || {};

    const { price, availableTransfers, paymentSchedule, selectedTransfers } = currentProposal;

    return {
      ...proposal,
      price: {
        ...proposal.price,
        ...price,
      },
      paymentSchedule,
      availableTransfers: availableTransfers || proposal.availableTransfers,
      selectedTransfers: selectedTransfers || proposal.selectedTransfers,
    };
  };

  return state.map(updateFn);
}

function updateTransportError(state: State, proposalId: string, error: HTTPError): State {
  const updateFn = proposal => ({
    ...proposal,
    transports: {
      ...proposal.transports,
      error,
    },
  });

  // $FlowFixMe
  return updateProposal(proposalId, state, updateFn);
}

function updateAttendees(state: State, proposalFields: TransferUpdateFields): State {
  if (!proposalFields) return state;

  const { price, attendees } = proposalFields;

  const updateFn = proposal => ({
    ...proposal,
    price,
    attendees: {
      ...proposal.attendees,
      list: attendees.list,
    },
  });

  // $FlowFixMe
  return updateProposal(proposalFields.id, state, updateFn);
}

export {
  setTransferIncludedInProposal,
  updateProposal,
  updateAttendees,
  updateTransfers,
  updateTransportError,
};
